<his-plam [hisDdKey]="dDKey">
	<div class="selectContainer">
		<p-autoComplete #content
			[(ngModel)]="selectedParent"
			[suggestions]="filteredParents"
			field="title"
			[size]="30"
			[minLength]="1"
			[hisDdKey]="dDKey"
			[forceSelection]="true"
			(completeMethod)="filterParent($event)"
			(onSelect)="onSelectByAutocomplete()"
			(onClear)="onClear()">
		</p-autoComplete>

        <his-search-select-popup
            #searchSelectPopup
			searchConfigFile="fs/res/searchPublicationParent.xml"
			[selectedOptions]="getParentList()"
			selectedOptionsIdColumn="Publication.id"
			[showDeleteButton]="false"
			[singleSelect]="true"
			(selectedOptionsChange)="onSelectBySearchPopup($event)"
            [defaultSearchGroup]="defaultSearchGroup"
            [hiddenSearchCriteriaPaths]="hiddenSearchCriteriaPaths">
            <div class="infoMessage">
				{{'fs.res.publication.search.parent.notFoundQuestion' | hisUi}}
			</div>
            <a *ngIf="auth.hasAnyArray(moduleOptions.RIGHT_CREATE) && saveWithoutMandatoryFieldsAuthorityLevel > 0" (click)="navigateToParentPublicationIfNoUnsavedChanges(true)" [routerLink]="" hisImage="context_add" class="transparent">
                <span>{{'fs.res.publication.Publication.parent.create' | hisUi}}</span>
            </a>
            <br>
		</his-search-select-popup>

		<!-- Parent bearbeiten -->
	    <a *ngIf="selectedParent && canEditParentPublication" class="transparent" [routerLink]="" tabindex="0"
			(click)="navigateToParentPublicationIfNoUnsavedChanges(false)" (keyup.enter)="navigateToParentPublicationIfNoUnsavedChanges(false)" hisImage="PENCIL">{{'fs.res.publication.Publication.parent.edit' | hisUi}}</a>

        <!-- Parent anlegen -->
        <a *ngIf="auth.hasAny('RIGHT_FS_RES_PUBLICATION_CREATE_PUBLICATION') && saveWithoutMandatoryFieldsAuthorityLevel > 0" (click)="navigateToParentPublicationIfNoUnsavedChanges(true)" (keyup.enter)="navigateToParentPublicationIfNoUnsavedChanges(true)" [routerLink]="" tabindex="0" hisImage="context_add" class="transparent">
            <span>{{'fs.res.publication.Publication.parent.create' | hisUi}}</span>
        </a>

		<!-- Zusatz-Informationen -->
		<div *ngIf="selectedParent" class="selectedContentInfo">
			<p *ngIf="selectedParent.creators?.length > 0">
				{{'fs.res.publication.Publication.editor.detailtext' | hisUi}}:
				<ng-container *ngFor="let creator of selectedParent.creators; last as lastCreator">
					{{creator.firstname}} {{creator.creatorname}}<span *ngIf="!lastCreator">, </span>
				</ng-container>
				<br/>
			</p>
			<p *ngIf="selectedParent.releaseYear">
				{{'fs.res.publication.Publication.releaseYear' | hisUi}}: {{selectedParent.releaseYear}}
			</p>
			<p *ngIf="selectedParent.publisher && selectedParent.publisher.label">
				{{'fs.res.publication.Publisher' | hisUi}}: {{selectedParent.publisher.label}}
			</p>
			<!-- Nur den Identifier mit der höchsten Priorität anzeigen -->
			<!-- TODO Ist der erste wirklich der mit der höchsten Priorität? -->
			<p *ngIf="selectedParent.globalIdentifiers?.length > 0">{{identifier()}}</p>
		</div>
	</div>

</his-plam>
